// src/layout/AppBarWithSearch.js
import * as React from 'react';
import { AppBar, TitlePortal } from 'react-admin';
import { Box } from '@mui/material';
import HeaderSearch from '../components/HeaderSearch';

export default function AppBarWithSearch(props) {
    return (
        <AppBar {...props}>
            <TitlePortal />
            <Box sx={{ flexGrow: 1 }} />
            <HeaderSearch />
        </AppBar>
    );
}
